module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-51.1a02418d.jpg";